import Conversion from './Conversion';

export default class JobSettings {
    prompt = '';
    prompt_invisible = '';
    negative_prompt = '';
    prompt_modifier = [];
    conversion = {};
    activeTool = 'texttoimage';
    image_gallery_index = null;
    similiarImageJob = {
        apiJob: null,
        analyzeJob: null,
        progress: null,
        base64: null,
        prompt: '',
    };

    constructor() {
        this.conversion = new Conversion();
    }
}
